module.exports = __webpack_public_path__ + "static/media/spa.ec3180af.webp";